import React from 'react';
import type { BombiixIconProps } from './types';

/**
 * Bombiix Card-view icon.
 * Uses `currentColor` so the parent `.bombiix-icon-container` modifier drives the tint.
 */
const CardViewIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M16.666 7.16992C16.9422 7.16992 17.166 7.39378 17.166 7.66992C17.166 7.94606 16.9422 8.16992 16.666 8.16992H3.33301C3.05687 8.16992 2.83301 7.94606 2.83301 7.66992C2.83301 7.39378 3.05687 7.16992 3.33301 7.16992H16.666Z"
      fill="currentColor"
    />
    <path
      d="M7.33301 12.5039C7.60915 12.5039 7.83301 12.7278 7.83301 13.0039C7.83301 13.28 7.60915 13.5039 7.33301 13.5039H6C5.72386 13.5039 5.5 13.28 5.5 13.0039C5.5 12.7278 5.72386 12.5039 6 12.5039H7.33301Z"
      fill="currentColor"
    />
    <path
      d="M11.667 12.5039C11.943 12.5041 12.167 12.7279 12.167 13.0039C12.167 13.2799 11.943 13.5037 11.667 13.5039H9C8.72386 13.5039 8.5 13.28 8.5 13.0039C8.5 12.7278 8.72386 12.5039 9 12.5039H11.667Z"
      fill="currentColor"
    />
    <path
      d="M16.166 12.7363V7.2627C16.166 6.0901 16.0055 5.55747 15.7217 5.27734C15.4355 4.99507 14.8898 4.83594 13.6992 4.83594H6.29297C5.10585 4.83594 4.56272 4.9953 4.27734 5.27734C3.99397 5.55753 3.83301 6.09015 3.83301 7.2627V12.7422C3.83301 13.9146 3.99358 14.4473 4.27637 14.7266C4.56114 15.0076 5.10459 15.1664 6.29199 15.1631H13.7061C14.8933 15.1631 15.4373 15.0038 15.7227 14.7217C16.006 14.4415 16.166 13.9086 16.166 12.7363ZM17.166 12.7363C17.166 13.9036 17.0306 14.8345 16.4258 15.4326C15.8228 16.0288 14.8854 16.1631 13.7061 16.1631H6.29297V16.1621C5.11438 16.1653 4.17753 16.0339 3.57422 15.4385C2.96887 14.841 2.83301 13.9094 2.83301 12.7422V7.2627C2.83301 6.09525 2.96926 5.16455 3.57422 4.56641C4.1772 3.97024 5.11368 3.83594 6.29297 3.83594H13.6992C14.8814 3.83594 15.82 3.96986 16.4238 4.56543C17.03 5.16364 17.166 6.09529 17.166 7.2627V12.7363Z"
      fill="currentColor"
    />
  </svg>
);

export default CardViewIcon;
